module.exports = __webpack_public_path__ + "img/img_real_name.a61101e1.jpg";